import { useEffect, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { Link, useLocation } from "react-router-dom";
import SearchedSchool from "./SearchedSchool";
import "./css/school_search_results_page.css";
import { apiUrl } from "../../../http-common";
import BookDemo from "./BookDemo";

const SchoolSearchResultsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDistrictTerm, setSearchDistrictTerm] = useState("");
  const [searchFilterOptions, setSearchFilterOptions] = useState([]);
  const [sortOption, setSortOption] = useState("Relevance");
  const [allSchoolsData, setAllSchoolsData] = useState([]);
  const [schoolSearchResults, setSchoolSearchResults] = useState([]);
  const [showFilterOptions, setShowFilterOptions] = useState(false);

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const querySearchTerm = urlParams.get("query") || "";
  const queryLocationSearchTerm = urlParams.get("location") || "";

  const search_filter_options = [
    "High",
    "Primary",
    "School",
    "College",
    "Academy",
  ];

  const search_sort_options = [
    "Relevance",
    "A-Z",
    "Z-A",
    "Rating: Highest first",
    "Rating: Lowest first",
    "District",
  ];

  // useEffect(
  //   function showSelectedFilterOptions() {
  //     console.log("selected filter options", searchFilterOptions);
  //   },
  //   [searchFilterOptions]
  // );

  useEffect(function loadAllSchoolsData() {
    const fetchSchools = async () => {
      try {
        const response = await fetch(
          `${apiUrl}institutions/schools-list/
  `,
          { method: "GET" }
        );

        const reduced_response = response.json();
        reduced_response.then((data) => {
          setAllSchoolsData(data);
        });
        setSearchTerm("");
        setSearchDistrictTerm("");
      } catch (error) {
        console.log(error);
      }
    };
    fetchSchools();
  }, []);

  // useEffect(() => {
  //   console.log("all schools", allSchoolsData);
  // }, [allSchoolsData]);

  function filterInstitutions(data, query) {
    // console.log("all schools", allSchoolsData);
    query = query.toLowerCase();

    return data.filter((institution) => {
      return Object.values(institution).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(query);
        } else if (Array.isArray(value)) {
          return value.some(
            (item) =>
              typeof item === "string" && item.toLowerCase().includes(query)
          );
        } else if (typeof value === "object" && value !== null) {
          return Object.values(value).some(
            (innerValue) =>
              typeof innerValue === "string" &&
              innerValue.toLowerCase().includes(query)
          );
        }
        return false;
      });
    });
  }

  function filterInstitutionsByQueries(data, queries) {
    if (!Array.isArray(queries) || queries.length === 0) return data;

    const lowerCaseQueries = queries.map((query) => query.toLowerCase());

    return data.filter((institution) => {
      return lowerCaseQueries.every((query) => {
        return Object.values(institution).some((value) => {
          if (typeof value === "string") {
            return value.toLowerCase().includes(query);
          } else if (Array.isArray(value)) {
            return value.some(
              (item) =>
                typeof item === "string" && item.toLowerCase().includes(query)
            );
          } else if (typeof value === "object" && value !== null) {
            return Object.values(value).some(
              (innerValue) =>
                typeof innerValue === "string" &&
                innerValue.toLowerCase().includes(query)
            );
          }
          return false;
        });
      });
    });
  }

  const sortInstitutions = (institutions, sortOption) => {
    return institutions.sort((a, b) => {
      switch (sortOption) {
        case "A-Z":
          return a.institution_name.localeCompare(b.institution_name);
        case "Z-A":
          return b.institution_name.localeCompare(a.institution_name);
        case "Rating: Highest first":
          return b.rating - a.rating;
        case "Rating: Lowest first":
          return a.rating - b.rating;
        case "District":
          return a.district.localeCompare(b.district);
        default:
          return 0;
      }
    });
  };

  useEffect(
    function setSearchTermAndDistrictTermAndLoadResultsOnMount() {
      setSearchTerm(querySearchTerm);
      setSearchDistrictTerm(queryLocationSearchTerm);
      if (querySearchTerm) {
        setSchoolSearchResults(
          filterInstitutions(allSchoolsData, querySearchTerm)
        );
      }
      if (queryLocationSearchTerm) {
        setSchoolSearchResults(
          filterInstitutions(allSchoolsData, queryLocationSearchTerm)
        );
      }
    },
    [querySearchTerm, queryLocationSearchTerm, allSchoolsData]
  );

  return (
    <div className="school_search_results_page">
      <div className="results_page_hero">
        <Header />
        <div className="search_for_school">
          <input
            type="text"
            value={searchTerm}
            name="institution_name"
            id="institution_name"
            placeholder="Enter School Name or Code"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
          />
          <input
            type="text"
            value={searchDistrictTerm}
            name="location"
            id="location"
            placeholder="Enter City or Region"
            onChange={(e) => {
              setSearchDistrictTerm(e.target.value);
            }}
          />
          <button
            className="search"
            onClick={() => {
              if (searchTerm) {
                setSchoolSearchResults(
                  filterInstitutions(allSchoolsData, searchTerm)
                );
              } else if (searchDistrictTerm) {
                setSchoolSearchResults(
                  filterInstitutions(allSchoolsData, searchDistrictTerm)
                );
              } else {
                setSchoolSearchResults([]);
              }
            }}
          >
            Search
          </button>
        </div>
      </div>
      <div className="results_container">
        <div className="top">
          <div className="left">
            <button
              className="filter"
              onClick={() => setShowFilterOptions(!showFilterOptions)}
            >
              Filter
            </button>
            <div
              className={`filter_options${
                !showFilterOptions ? " displayed_none" : ""
              }`}
            >
              {search_filter_options.map((filter_option, index) => (
                <div key={index} className="filter_option">
                  <input
                    type="checkbox"
                    name="school_search_filters"
                    id={filter_option}
                    value={filter_option}
                    checked={searchFilterOptions.includes(filter_option)}
                    onChange={(e) => {
                      setSearchFilterOptions((prev) => {
                        const updatedFilters = prev.includes(e.target.value)
                          ? prev.filter(
                              (filter_option) =>
                                filter_option.toLowerCase() !==
                                e.target.value.toLowerCase()
                            )
                          : [...prev, e.target.value];

                        setSchoolSearchResults(
                          filterInstitutionsByQueries(
                            allSchoolsData,
                            updatedFilters
                          )
                        );

                        return updatedFilters;
                      });
                    }}
                  />
                  <label htmlFor={filter_option}>{filter_option}</label>
                </div>
              ))}
            </div>
            <div className="selected_filter_options">
              {searchFilterOptions.length > 0 &&
                searchFilterOptions.map((selected_filter_option, index) => (
                  <div key={index} className="selected_filter_option">
                    <span className="selected_filter_option_value">
                      {selected_filter_option}
                    </span>
                    <button
                      className="deselected_filter_option"
                      data-selected-filter-option-value={selected_filter_option}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();

                        setSearchFilterOptions((prev) => {
                          const updatedFilters = prev.filter(
                            (filter_option) =>
                              filter_option.toLowerCase() !==
                              e.target
                                .getAttribute(
                                  "data-selected-filter-option-value"
                                )
                                .toLowerCase()
                          );

                          setSchoolSearchResults(
                            filterInstitutionsByQueries(
                              allSchoolsData,
                              updatedFilters
                            )
                          );

                          return updatedFilters;
                        });
                      }}
                    ></button>
                  </div>
                ))}
            </div>
          </div>
          <div className="right">
            <div className="sort">
              <span>Sort by:</span>
              <select
                name="sort_options"
                id="sort_options"
                value={sortOption}
                onChange={(e) => {
                  const selectedSort = e.target.value;
                  setSortOption(selectedSort);

                  const sortedResults = sortInstitutions(
                    [...schoolSearchResults],
                    selectedSort
                  );
                  setSchoolSearchResults(sortedResults);
                }}
              >
                {search_sort_options.map((sort_option, index) => (
                  <option key={index} value={sort_option}>
                    {sort_option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="bottom">
          <h1>
            {schoolSearchResults?.length}&nbsp;school
            {schoolSearchResults?.length === 1 ? "" : "s"} found
          </h1>
          <div className="searched_schools_container">
            {schoolSearchResults?.length > 0 &&
              schoolSearchResults.map(
                (
                  {
                    rating,
                    institution_name,
                    institution_district,
                    banner,
                    tenant_id,
                  },
                  index
                ) => (
                  <SearchedSchool
                    key={index}
                    rating={rating}
                    name={institution_name}
                    district={institution_district}
                    banner={banner}
                    url={`/school_details/${tenant_id}`}
                  />
                )
              )}
          </div>
        </div>
      </div>
      <Footer />
      <BookDemo />
    </div>
  );
};

export default SchoolSearchResultsPage;
